const smoothscroll =require('smoothscroll-polyfill');
exports.onClientEntry = () => {
    console.log(smoothscroll)
    smoothscroll.polyfill();
  }